import { __extends } from "tslib";
export function assert(bool, msg) {
    if (!bool) {
        throw new ValidationError(msg);
    }
}
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(m) {
        var _this = _super.call(this, m) || this;
        // Set the prototype explicitly.
        Object.setPrototypeOf(_this, ValidationError.prototype);
        return _this;
    }
    return ValidationError;
}(Error));
//# sourceMappingURL=errors.js.map